import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Glass from '../Glass'
import API from '../../apis'
import './style.scss'
import System from '../../store/system'

const emailReg = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/gi

interface Alert {
  type: 'error' | 'success'
  message: string
}

const Email: React.FC = () => {
  const [email, setEmail] = useState('')
  const [alert, setAlert] = useState<Alert | null>(null)
  const { t } = useTranslation('trans', { keyPrefix: 'footer' })
  const { isMobile } = System.useContainer()

  const handleAlert = (alert: Alert): void => {
    setAlert(alert)
    setTimeout(
      () => {
        setAlert(null)
      },
      alert.type === 'error' ? 3000 : 1000
    )
  }

  const handleSubscribe = (): void => {
    if (!emailReg.test(email)) {
      handleAlert({
        type: 'error',
        message: t('alert.notemail'),
      })
      return
    }
    API.subscribe(email)
      .then(() => {
        handleAlert({
          type: 'success',
          message: t('alert.success'),
        })
      })
      .catch(() => {})
  }

  return (
    <Glass className="email" classic={isMobile}>
      {alert && (
        <div className={`alert glass-bg ${alert.type}`}>{alert.message}</div>
      )}
      <input
        type="text"
        placeholder={t('email.placeholder')}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button onClick={handleSubscribe}>{t('email.submit')}</button>
    </Glass>
  )
}

const Footer: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'footer' })

  return (
    <footer className="glass-bg">
      <div className="title">{t('follow')}</div>
      <Email />
      <div className="admin-email">
        <a href={`mailto:${t('adminEmail')}`}>{t('adminEmail')}</a>
      </div>
    </footer>
  )
}

export default Footer
